var _path, _path2, _path3, _path4, _path5, _polygon, _polygon2, _path6, _path7;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function Svg01(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 141 22.3",
    style: {
      enableBackground: "new 0 0 141 22.3"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "logo-a1",
    d: "M0.6,10.5c0.5-2.6,2.8-4.4,6-4.4c3.7,0,6.6,1.6,6.6,6.6V22H10l-0.4-2c-1.1,1.4-2.6,2.3-4.8,2.3c-2.7,0-4.8-1.7-4.8-4.8s2.8-5.1,6.7-5.1h2.6v-0.7c0-1.8-1.3-2.3-2.8-2.3c-1.1,0-2.2,0.4-2.7,1.8L0.6,10.5z M5.7,19c1.8,0,3.6-1.2,3.6-3.2v-0.3H6.8c-1.7-0.1-2.7,0.6-2.7,2C4.1,18.2,4.7,19,5.7,19z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "logo-a2",
    d: "M76,10.5c0.5-2.6,2.8-4.4,6-4.4c3.7,0,6.6,1.6,6.6,6.6V22h-3.2L85,20c-1.1,1.4-2.6,2.3-4.8,2.3c-2.7,0-4.8-1.7-4.8-4.8s2.8-5.1,6.7-5.1h2.6v-0.7c0-1.8-1.3-2.3-2.8-2.3c-1.1,0-2.2,0.4-2.7,1.8L76,10.5z M81.1,19c1.8,0,3.6-1.2,3.6-3.2v-0.3h-2.6c-1.7,0-2.7,0.6-2.7,2C79.5,18.2,80.1,19,81.1,19z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    id: "logo-r",
    d: "M92.1,22.1V6.3H96v2.6c1.1-1.9,2.9-2.8,4.6-2.8c0.7,0,1.3,0.1,1.9,0.3l-0.7,3.6c-0.5-0.3-1-0.5-1.6-0.5c-2.3,0-4.2,1.9-4.2,6.9V22L92.1,22.1L92.1,22.1z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    id: "logo-d",
    d: "M110.8,6.1c1.6,0,3.1,0.8,3.8,1.7V0h3.9v22.1h-3.9v-1.6c-0.5,0.8-1.9,1.9-3.8,1.9c-4.7,0-7.1-3.3-7.1-8.1S106.1,6.1,110.8,6.1z M111.4,19c2,0,3.6-1.7,3.6-4.8s-1.6-4.8-3.6-4.8c-2,0-3.6,1.7-3.6,4.8S109.4,19,111.4,19z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    id: "logo-s",
    d: "M132.5,8.6l-2.3,2.1c-0.7-1-1.8-1.4-2.6-1.4c-0.8,0-1.5,0.5-1.5,1.3c0,0.7,0.6,1.2,1.5,1.5c2.2,0.8,5.7,1.5,5.7,4.8c0,2.9-2.2,5.2-5.6,5.2c-3.3,0-5.5-2.3-6.2-4.2l3.1-1.7c0.6,1.5,1.6,2.6,3.2,2.6c1.2,0,2-0.6,2-1.7c0-1.3-2-1.6-3.9-2.4c-1.7-0.7-3.2-1.8-3.2-4.2s2-4.6,5-4.6C129.7,6,131.6,7.1,132.5,8.6z"
  })), _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    id: "logo-w2",
    points: "51.9,6.3 49.1,17.2 46.4,6.3 42.8,6.3 40.2,17.2 38,10.9 37.7,11.6 36.5,15.7 38.5,22.1 41.9,22.1 44.6,11.9 47.3,22.1 50.8,22.1 55.8,6.3 "
  })), _polygon2 || (_polygon2 = /*#__PURE__*/React.createElement("polygon", {
    id: "logo-w3",
    points: "70.6,6.3 67.8,17.2 65.1,6.3 61.5,6.3 58.9,17.2 56.7,10.9 56.4,11.6 55.1,15.7 57.2,22.1 60.6,22.1 63.3,11.9 66,22.1 69.4,22.1 74.5,6.3 "
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    id: "logo-w1",
    d: "M37.1,6.3l-5,15.7h-3.4L26,11.9l-2.7,10.2h-3.4l-5-15.7h3.9l2.8,10.8l2.7-10.8h3.6l2.7,10.8l2.8-10.8L37.1,6.3L37.1,6.3z"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    id: "logo-p",
    d: "M138.4,17c1.5,0,2.6,1.1,2.6,2.6s-1.1,2.6-2.6,2.6s-2.6-1.1-2.6-2.6S136.9,17,138.4,17z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(Svg01);
export default __webpack_public_path__ + "static/media/01.be21cf47ba897e0b75efa0f1e56fb86d.svg";
export { ForwardRef as ReactComponent };